import { callable } from '../callable';

export type MentorCadence = 'weekly' | 'biweekly' | 'monthly' | 'adhoc';

export interface MentorPairingDto {
  studentId: string;
  mentorPersonId: string | null;
  mentorName: string | null;
  mentorEmail: string | null;
  cadence: MentorCadence;
  nextSlot: string | null;
}

export interface MentorSessionDto {
  id: string;
  date: string;
  duration: string;
  topic: string;
  notes: string;
}

export const mentorApi = {
  getMyPairing: async (data: {
    tenantId: string;
    studentId?: string;
  }): Promise<MentorPairingDto> => {
    const fn = callable<typeof data, MentorPairingDto>('getMyMentorPairing');
    return (await fn(data)).data;
  },
  updateMyPairing: async (data: {
    tenantId: string;
    studentId?: string;
    mentorPersonId?: string | null;
    mentorName?: string | null;
    mentorEmail?: string | null;
    cadence?: MentorCadence;
    nextSlot?: string | null;
  }): Promise<{ success: boolean }> => {
    const fn = callable<typeof data, { success: boolean }>('updateMyMentorPairing');
    return (await fn(data)).data;
  },
  listMySessions: async (data: {
    tenantId: string;
    studentId?: string;
  }): Promise<{ items: MentorSessionDto[] }> => {
    const fn = callable<typeof data, { items: MentorSessionDto[] }>('listMyMentorSessions');
    return (await fn(data)).data;
  },
  createMySession: async (data: {
    tenantId: string;
    studentId?: string;
    date: string;
    duration?: string;
    topic?: string;
    notes?: string;
  }): Promise<{ id: string }> => {
    const fn = callable<typeof data, { id: string }>('createMyMentorSession');
    return (await fn(data)).data;
  },
  updateMySession: async (data: {
    tenantId: string;
    sessionId: string;
    patch: { date?: string; duration?: string; topic?: string; notes?: string };
  }): Promise<{ success: boolean }> => {
    const fn = callable<typeof data, { success: boolean }>('updateMyMentorSession');
    return (await fn(data)).data;
  },
  deleteMySession: async (data: {
    tenantId: string;
    sessionId: string;
  }): Promise<{ success: boolean }> => {
    const fn = callable<typeof data, { success: boolean }>('deleteMyMentorSession');
    return (await fn(data)).data;
  },
};
